/** Alinhado ao backend `carouselMedia.ts` — carrossel da landing do produto. */
const IMAGE_EXTENSIONS = new Set(['.png', '.jpg', '.jpeg', '.webp', '.gif']);
const VIDEO_EXTENSIONS = new Set(['.mp4', '.webm', '.mov', '.avi', '.mkv']);

export type CarouselMediaType = 'video' | 'image';

function getExtension(filename: string): string {
  const i = filename.lastIndexOf('.');
  return i >= 0 ? filename.slice(i).toLowerCase() : '';
}

export function getCarouselMediaTypeFromFilename(filename: string): CarouselMediaType {
  const ext = getExtension(filename);
  if (VIDEO_EXTENSIONS.has(ext)) return 'video';
  if (IMAGE_EXTENSIONS.has(ext)) return 'image';
  return 'video';
}

/** API pode omitir `mediaType` em deploys antigos — infere pelo nome do arquivo. */
export function resolveCarouselMediaType(
  filename: string,
  apiMediaType?: string | null
): CarouselMediaType {
  if (apiMediaType === 'image' || apiMediaType === 'video') return apiMediaType;
  return getCarouselMediaTypeFromFilename(filename);
}
